import { Routes } from '@angular/router';

import { MainLayoutComponent } from './features/public/layout/main-layout.component/main-layout.component';
import { Landing } from './features/public/landing/landing';
import { Shop } from './features/public/shop/shop';
import { ProductDetail } from './features/public/product-detail/product-detail';
import { CheckoutComponent } from './features/public/checkout.component/checkout.component';
import { CheckoutResultComponent } from './features/public/checkout-result/checkout-result.component';

import { AdminLayoutComponent } from './features/admin/layout/admin-layout.component/admin-layout.component';
import { Dashboard } from './features/admin/dashboard/dashboard/dashboard';
import { CategoriesAdminComponent } from './features/admin/categories-admin/categories-admin';
import { BrandsAdminComponent } from './features/admin/brands-admin/brands-admin';
import { SizesAdminComponent } from './features/admin/size-admin/size-admin';
import { ProductsAdminComponent } from './features/admin/products/products-admin.component/products-admin.component';
import { adminGuard } from './core/security/admin-guard';
import { NewOrderComponent } from './features/admin/new-order.component/new-order.component';
import { OrdersListComponent } from './features/admin/orders-list.component/orders-list.component';
import { OrdersHistoryComponent } from './features/admin/orders-history.component/orders-history.component';
import { PaymentMethodsAdminComponent } from './features/admin/payment-methods-admin.component/payment-methods-admin.component';
import {PaymentVerification} from './features/admin/web-orders/payment-verification/payment-verification';
import {DeliveryManagementComponent} from './features/admin/web-orders/delivery-management/delivery-management';
import {WebOrdersHistory} from './features/admin/web-orders/web-orders-history/web-orders-history';
import {WebOrdersFinance} from './features/admin/web-orders/web-orders-finance/web-orders-finance';
import {UserManagementComponent} from './features/admin/user-management.component/user-management.component';
import {StockControlComponent} from './features/admin/stock-control.component/stock-control.component';
import {UserProfileComponent} from './features/public/user-profile.component/user-profile.component';
import { ColorsAdminComponent } from './features/admin/colors-admin/colors-admin';
import { AuditLogsComponent } from './features/admin/audit-logs/audit-logs';
import { ModelosComponent } from './features/admin/modelos-admin/modelos.component';
import { UbigeoAdminComponent } from './features/admin/ubigeo-admin/ubigeo-admin';
import { EstadosAdminComponent } from './features/admin/estados-admin/estados-admin';
import { TipoEnvioAdminComponent } from './features/admin/tipo-envio-admin/tipo-envio-admin';
import { OrigenVentaAdminComponent } from './features/admin/origen-venta-admin/origen-venta-admin';
import { TipoMonedaAdminComponent } from './features/admin/tipo-moneda-admin/tipo-moneda-admin';
import { ClientesAdminComponent } from './features/admin/clientes-admin/clientes-admin';
import { BoletasAdminComponent } from './features/admin/boletas-admin/boletas-admin';
import { Club } from './features/public/club/club';
import { NewsletterAdminComponent } from './features/admin/newsletter-admin/newsletter-admin';



export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', component: Landing },
      { path: 'shop', component: Shop },
      { path: 'product/:slug', component: ProductDetail },
      { path: 'checkout', component: CheckoutComponent },
      { path: 'checkout/result', component: CheckoutResultComponent },
      { path: 'checkout/success', component: CheckoutResultComponent },
      { path: 'checkout/failure', component: CheckoutResultComponent },
      { path: 'checkout/pending', component: CheckoutResultComponent },
      {path: 'profile', component: UserProfileComponent},
      { path: 'club', component: Club }
    ]
  },

  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [adminGuard],
    children: [
      { path: 'dashboard', component: Dashboard },

      { path: 'products', component: ProductsAdminComponent },
      { path: 'categories', component: CategoriesAdminComponent },
      { path: 'brands', component: BrandsAdminComponent },
      { path: 'modelos', component: ModelosComponent },
      { path: 'sizes', component: SizesAdminComponent },
      { path: 'colors', component: ColorsAdminComponent },

      { path: 'orders/new', component: NewOrderComponent },
      { path: 'orders/active', component: OrdersListComponent },
      { path: 'orders/history', component: OrdersHistoryComponent },
      { path: 'orders/edit/:id', component: NewOrderComponent },

      { path: 'web-orders/verify', component: PaymentVerification },
      { path: 'web-orders/delivery', component: DeliveryManagementComponent },
      { path: 'web-orders/history', component: WebOrdersHistory },
      { path: 'web-orders/finance', component: WebOrdersFinance },
      { path: 'payment-methods', component: PaymentMethodsAdminComponent },

      { path: 'users', component: UserManagementComponent },

      { path: 'stock', component: StockControlComponent },

      { path: 'estados', component: EstadosAdminComponent },
      { path: 'tipo-envio', component: TipoEnvioAdminComponent },
      { path: 'origen-venta', component: OrigenVentaAdminComponent },
      { path: 'tipo-moneda', component: TipoMonedaAdminComponent },
      { path: 'clientes', component: ClientesAdminComponent },
      { path: 'ubigeo', component: UbigeoAdminComponent },
      { path: 'audit', component: AuditLogsComponent },
      { path: 'boletas', component: BoletasAdminComponent },
      { path: 'newsletter', component: NewsletterAdminComponent },

      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '' }
];